import React, { forwardRef, useImperativeHandle, useRef, useMemo } from 'react';
import { GenericSettingsPane, GenericSettingsPaneHandle } from './GenericSettingsPane';
import { PaneHandle, PaneProps } from '../accountParameter.types';
import { useStoreState } from '../../../../models/hooks';
import { useTranslation } from 'react-i18next';

export const RequisitionPane = forwardRef<PaneHandle, PaneProps>(({ onSave, setDirty, showActions }, ref) => {
  const genericPaneRef = useRef<GenericSettingsPaneHandle>(null);
  const account = useStoreState((state) => state.app.accounts);
  const { t } = useTranslation('accountParameter');

  useImperativeHandle(ref, () => ({
    save: () => genericPaneRef.current?.save(),
    reset: () => genericPaneRef.current?.reset(),
  }));

  const items = useMemo(
    () => [
      // {
      //   key: 'requisitionEnabled',
      //   label: 'Requisition Enabled',
      //   description: 'Enable the requisition on account.',
      //   value: account?.configuration?.requisitionEnabled ?? true,
      //   type: 'boolean' as const,
      // },
      {
        key: 'hireFormEnabled',
        label: t('requisitionPane.hireFormEnabled'),
        description: t('requisitionPane.hireFormEnabledDescription'),
        value: account?.configuration?.hireFormEnabled ?? false,
        type: 'boolean' as const,
      },
      //condition> only if hire form enabled
      {
        key: 'hireFormTemplateEnabled',
        label: t('requisitionPane.hireFormTemplateEnabled'),
        description: t('requisitionPane.hireFormTemplateEnabledDescription'),
        value: account?.configuration?.hireFormTemplateEnabled ?? false,
        type: 'boolean' as const,
      },

      {
        key: 'requisitionWebHookRetryCount',
        label: t('requisitionPane.requisitionWebhookRetryCount'),
        description: t('requisitionPane.requisitionWebhookRetryCountDescription'),
        value: account?.configuration?.requisitionWebHookRetryCount ?? 3,
        unit: t('requisitionPane.retries'),
        min: 0,
        max: 10,
        type: 'number' as const,
      },

      {
        key: 'requisitionActiveThresholdDays',
        label: t('requisitionPane.requisitionActiveThresholdDays'),
        description: t('requisitionPane.requisitionActiveThresholdDaysDescription'),
        value: account?.configuration?.requisitionActiveThresholdDays ?? 30,
        unit: t('requisitionPane.days'),
        min: 0,
        max: 180,
        type: 'number' as const,
      },
    ],
    [account, t],
  );

  return <GenericSettingsPane ref={genericPaneRef} onSave={onSave} setDirty={setDirty} showInlineActions={showActions} items={items} />;
});
